import { alpha, IconButton, styled } from '@mui/material'
import { colors } from './colors.theme'

const { white } = colors

const iconButtonColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        color: val,
      },
    ]
  }),
)

export const iconButtonTheme = {
  root: {
    ...iconButtonColors,
    '&.Mui-disabled': {
      opacity: 0.4,
    },
  },
}

const iconButtonBgColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        backgroundColor: `${alpha(val, 0.2)} !important`,
      },
    ]
  }),
)

export const IconButtonBg = styled(IconButton)(() => ({
  backgroundColor: alpha(white, 0.1),
  borderRadius: '8px',
  ...iconButtonBgColors,
}))
